export enum ExpendableType{
    CLASS='Class',
    SCROLL='Scroll',
    POTION='Potion',
    CHARGE='Charge',
}